import { JSX } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { usePrincipal } from "authentication/AuthProvider";

export type AuthenticatedProps = {
	children: JSX.Element;
};

function Authenticated(): JSX.Element {
	const location = useLocation();
	const principal = usePrincipal();

	if (principal === undefined) {
		return <></>;
	}

	// TODO: just show the eula page on the current page.
	// If the user does not accept it, sign him out.
	if (!principal?.signedEula || !principal?.hasOrganisation()) {
		return <Navigate to={"/login"} state={location} replace />;
	}

	if (principal.isExpired()) {
		return <></>;
	}

	return <Outlet />;
}

export default Authenticated;
